<div class="controls-container">
    <div class="controls-header">Primitives</div>

    <div class="controls-sub-header">Badges</div>

    <div class="controls-badge">
        <div>
            Notifications <pm-badge>4</pm-badge>
        </div>
    </div>

    <div class="controls-sub-header">Links</div>

    <pm-link Href="https://github.com/claygifford/pm-controls">https://github.com/claygifford/pm-controls</pm-link>
    
    <div class="controls-sub-header">Fields</div>

    <pm-field [Label]="'Field: '" [Content]="'Value'"></pm-field>

    <div class="controls-sub-header">Labels</div>

    <pm-label [Label]="'Label '"></pm-label>


    <div class="controls-sub-header">Thumb</div>

    <div style="display: flex; height: 40px; width: 200px;">
        <div style="background-color: #ff5252; flex: 1;"></div>
        <pm-thumb [ItemOrientation]="'Horizontal'"></pm-thumb>
        <div style="background-color: #1E88E5; flex: 1;"></div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/primitives/primitives.html